<template>
  <main id="client" class="page-container" v-if="$route.name === 'customers'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->
    <div class="table-container-clients">
      <div class="clients-toolbar">
        <router-link to="/home/clients/add-client" class="primary-btn">
          + Nuovo cliente
        </router-link>
      </div>

      <div class="tbl-wrap">
        <table ref="fitTable" class="tbl client-table">
          <thead>
            <tr>
              <th id="nome-cliente">Nome cliente</th>
              <th id="sede" class="col-secondary">Sede</th>
              <th id="ultimo-preventivo" class="col-secondary">
                Ultimo preventivo
              </th>
              <th class="actions-col"></th>
            </tr>
          </thead>

          <tbody>
            <!-- due <tr> per cliente come prima -->
            <template v-for="(client, index) in allClients" :key="index">
              <tr
                class="client-row row-clickable"
                @click="onRowClick($event, client)"
              >
                <td>{{ client.clientName }}</td>

                <td class="col-secondary">
                  <a
                    v-if="
                      client.legalHeadquarters && client.legalHeadquarters.link
                    "
                    :href="client.legalHeadquarters.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="custom-link"
                  >
                    {{
                      client.legalHeadquarters.address ||
                      "Indirizzo non disponibile"
                    }}
                  </a>
                  <span
                    v-else-if="
                      client.legalHeadquarters &&
                      client.legalHeadquarters.address
                    "
                    >{{ client.legalHeadquarters.address }}</span
                  >
                  <span v-else>Indirizzo non disponibile</span>
                </td>

                <td class="col-secondary">
                  <template v-if="client.lastQuote">
                    <span>{{
                      formatToLocalDateAndHours(client.lastQuote)
                    }}</span>
                  </template>
                  <template v-else>
                    <span>Nessun preventivo</span>
                  </template>
                </td>

                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="showSoldItems(client)"
                    title="Articoli venduti/da ordinare"
                    aria-label="Articoli venduti/da ordinare"
                  >
                    <i class="fa-solid fa-box"></i>
                  </button>
                  <button
                    class="icons-button"
                    @click="goToEditClient(client.id)"
                    title="Modifica cliente"
                    aria-label="Modifica cliente"
                  >
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button
                    class="icons-button"
                    @click="openArchiveModal(client)"
                    title="Archivia cliente"
                    aria-label="Archivia cliente"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Paginazione / search -->
      <div class="pagination">
        <div class="search-container">
          <input
            type="text"
            v-model="searchTerm"
            @keyup.enter="onSearch"
            placeholder="Cerca clienti..."
            class="search-box"
            :disabled="isLoading"
          />
          <button
            v-if="searchTerm"
            @click="onResetSearch"
            class="clear-search-button"
            :disabled="isLoading"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        <div class="pagination-info">
          {{ pagination.startItem }}-{{ pagination.endItem }} di
          {{ pagination.totalItems }}
        </div>

        <div class="pagination-controls">
          <button
            class="icons-button"
            @click="goToPage(1)"
            :disabled="isLoading || pagination.currentPage === 1"
            :title="
              isLoading || pagination.currentPage === 1
                ? null
                : 'Torna alla prima pagina'
            "
          >
            <i class="fa-solid fa-angles-left"></i>
          </button>

          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage - 1)"
            :disabled="isLoading || pagination.currentPage === 1"
            :title="
              isLoading || pagination.currentPage === 1
                ? null
                : 'Torna alla pagina precedente'
            "
          >
            <i class="fa-solid fa-chevron-left"></i>
          </button>

          <button
            v-for="pageNum in visiblePages"
            :key="pageNum"
            @click="goToPage(pageNum)"
            :class="{ active: pagination.currentPage === pageNum }"
            class="pages-button"
          >
            {{ pageNum }}
          </button>

          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage + 1)"
            :disabled="
              isLoading || pagination.currentPage === pagination.totalPages
            "
            :title="
              isLoading || pagination.currentPage === pagination.totalPages
                ? null
                : 'Vai alla pagina successiva'
            "
          >
            <i class="fa-solid fa-chevron-right"></i>
          </button>

          <button
            class="icons-button"
            @click="goToPage(pagination.totalPages)"
            :disabled="
              isLoading || pagination.currentPage === pagination.totalPages
            "
            :title="
              isLoading || pagination.currentPage === pagination.totalPages
                ? null
                : `Vai all'ultima pagina`
            "
          >
            <i class="fa-solid fa-angles-right"></i>
          </button>
        </div>
      </div>

      <VueFinalModal
        v-model="showItemsModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="client-info-modal-content"
      >
        <template #default>
          <button class="modal__close icons-button" @click="closeItemsModal">
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Articoli venduti/da ordinare</h3>

          <!-- barra ricerca -->
          <div class="documents-search">
            <div class="search-wrapper">
              <!-- <font-awesome-icon
                class="search-icon"
                :icon="['fas', 'magnifying-glass']"
              /> -->
              <i class="fa-solid fa-magnifying-glass search-icon"></i>
              <input
                type="text"
                v-model="itemSearch"
                placeholder="Cerca un articolo…"
                class="search-doc-input"
              />
            </div>
          </div>

          <transition-group
            name="card"
            tag="div"
            class="documents-grid"
            :key="itemSearch"
          >
            <div
              v-for="it in filteredItems"
              :key="itemKeyStable(it)"
              class="document-card"
            >
              <div class="card-link">
                <div class="card-icon">
                  <!-- Fuori magazzino -->
                  <i
                    v-if="isOutstock(it)"
                    class="fa-solid fa-truck"
                    aria-hidden="true"
                  ></i>

                  <!-- Piastrelle -->
                  <img
                    v-else-if="isTile(it)"
                    src="@/assets/tile.png"
                    alt=""
                    class="card-icon-img"
                  />

                  <!-- Sanitari -->
                  <img
                    v-else-if="isSanitary(it)"
                    src="@/assets/sanitari.png"
                    alt=""
                    class="card-icon-img"
                  />

                  <!-- Fallback generico -->
                  <i v-else class="fa-solid fa-box-open" aria-hidden="true"></i>
                </div>

                <div class="card-body">
                  <div class="card-title">
                    {{
                      it.name ||
                      it.itemName ||
                      it.subBrand ||
                      it.brand ||
                      "Articolo"
                    }}
                  </div>

                  <div class="card-subtitle">
                    <!-- <div>
                      <strong>Nome articolo:</strong>
                      {{ it.name || it.brand || it.subBrand }}
                    </div> -->
                    <div><strong>Categoria:</strong> {{ it.category }}</div>
                    <!-- Se è piastrella e ho il calcolo mq, mostro i mq -->
                    <!-- Altrimenti mostro la quantità "a pezzi/scatole" -->
                    <!-- <div v-if="isTile(it) && it.mqxquantity">
                      <strong>Quantità al mq:</strong>
                      {{ Number(it.mqxquantity).toFixed(2) }} mq
                    </div>

                    <div v-else>
                      <strong>Quantità:</strong> {{ it.quantity }}
                    </div> -->
                    <div>
                      <strong>{{ getItemLabel(it) }}</strong>
                      <template v-if="isTile(it) && it.mqxquantity">
                        {{ Number(it.mqxquantity).toFixed(2) }} mq
                      </template>
                      <template v-else>
                        {{ it.quantity }}
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </transition-group>

          <div v-if="!filteredItems.length" class="no-result">
            Nessun articolo trovato
          </div>
        </template>
      </VueFinalModal>

      <VueFinalModal
        v-model="showArchiveModal"
        :clickToClose="!archiving"
        :escToClose="!archiving"
        classes="documents-modal"
        content-class="confirm-modal-content modal--archive"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeArchiveModal"
            :disabled="archiving"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Archivia cliente</h3>
          <p class="modal__subtitle">
            Sei sicuro di voler archiviare
            <strong>{{ selectedClient?.clientName }}</strong
            >?
          </p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="closeArchiveModal"
              :disabled="archiving"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="confirmArchive"
              :disabled="archiving"
            >
              <span v-if="archiving">Archivia…</span>
              <span v-else>Archivia</span>
            </button>
          </div>
        </template>
      </VueFinalModal>

      <!-- [sc-49210] Dettaglio riga: le colonne secondarie -->
      <RowDetailsModal
        v-model="showRowDetails"
        :title="rowDetailsClient?.clientName || 'Cliente'"
      >
        <template v-if="rowDetailsClient">
          <div>
            <dt>Sede</dt>
            <dd>
              <a
                v-if="rowDetailsClient.legalHeadquarters?.link"
                :href="rowDetailsClient.legalHeadquarters.link"
                target="_blank"
                rel="noopener noreferrer"
                class="custom-link"
              >
                {{
                  rowDetailsClient.legalHeadquarters.address ||
                  "Indirizzo non disponibile"
                }}
              </a>
              <span v-else-if="rowDetailsClient.legalHeadquarters?.address">{{
                rowDetailsClient.legalHeadquarters.address
              }}</span>
              <span v-else>Indirizzo non disponibile</span>
            </dd>
          </div>
          <div>
            <dt>Ultimo preventivo</dt>
            <dd>
              <span v-if="rowDetailsClient.lastQuote">{{
                formatToLocalDateAndHours(rowDetailsClient.lastQuote)
              }}</span>
              <span v-else>Nessun preventivo</span>
            </dd>
          </div>
        </template>
      </RowDetailsModal>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDateAndHours } from "../utilities/formatting";
import RowDetailsModal from "@/components/RowDetailsModal.vue";
import { shouldOpenRowDetails } from "@/utilities/rowDetails";
import { fitPageSizeMixin } from "@/utilities/fitPageSize";

export default {
  // [sc-49210] elementi per pagina calcolati dallo schermo (pageSize)
  mixins: [fitPageSizeMixin],
  components: { RowDetailsModal },
  computed: {
    ...mapGetters({
      allClients: "clients/list",
      pagination: "clients/pagination",
    }),

    visiblePages() {
      const range = 2;
      const start = Math.max(1, this.pagination.currentPage - range);
      const end = Math.min(
        this.pagination.totalPages,
        this.pagination.currentPage + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    /* filtro live sugli articoli */
    filteredItems() {
      const q = (this.itemSearch || "").toLowerCase().trim();
      if (!q) return this.soldItems;

      // cerco su più campi concatenati
      return this.soldItems.filter((it) => {
        const haystack = [
          it.itemName,
          it.subBrand,
          it.name,
          it.brand,
          it.category,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return haystack.includes(q);
      });
    },
  },
  data() {
    return {
      // clients: [],
      errorMessage: "",
      successMessage: "",
      isLoading: false,
      searchTerm: "",

      /* ===  MODAL Articoli  === */
      showItemsModal: false,
      soldItems: [], // array di articoli {id,itemName,quantity,price}
      itemSearch: "",
      showArchiveModal: false,
      archiving: false,
      selectedClient: null,
      showRowDetails: false,
      rowDetailsClient: null,
    };
  },
  methods: {
    // [sc-49210] il numero di righe che stanno nello schermo è cambiato
    onPageSizeChange() {
      return this.getClients(1);
    },
    ...mapActions(["fetchClients", "archiveClient", "fetchClientSoldItems"]),

    onRowClick(event, client) {
      if (!shouldOpenRowDetails(event)) return;
      this.rowDetailsClient = client;
      this.showRowDetails = true;
    },

    itemKeyStable(it) {
      return (
        it.id ??
        it.itemId ??
        it.outstockId ??
        it.code ??
        `${it.category || "x"}-${
          it.name || it.brand || it.itemName || it.subBrand || "unk"
        }`
      );
    },

    // isOutstock(it) {
    //   const c = (it.category || "").toLowerCase();
    //   return c.includes("fuori") && c.includes("magazzino");
    // },
    isOutstock(it) {
      return !!it.outstockId; // vero per articoli fuori magazzino
    },
    isTile(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("piastrelle") || c.includes("piastrella");
    },
    isSanitary(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("sanitari") || c.includes("sanitario");
    },

    /* etichetta quantità in mq o pezzi */
    getItemLabel(item) {
      return this.isTile(item) && item.mqxquantity
        ? "Quantità al mq: "
        : "Quantità: ";
    },

    /* apre il modal, carica gli articoli */
    async showSoldItems(client) {
      try {
        this.showItemsModal = true;
        //  ► chiedi gli articoli al backend / store
        const resp = await this.fetchClientSoldItems(client.id);
        //  ► salva nello stato locale
        this.soldItems = resp; // resp = array di articoli
      } catch (e) {
        // console.error(e);
        this.errorMessage =
          "Impossibile caricare gli articoli di questo cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    closeItemsModal() {
      this.showItemsModal = false;
      this.soldItems = [];
      this.itemSearch = "";
    },

    openArchiveModal(client) {
      this.selectedClient = client;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      if (this.archiving) return; // evita chiusure durante la richiesta
      this.showArchiveModal = false;
      this.selectedClient = null;
    },

    formatToLocalDateAndHours,

    async getClients(page = 1, search = this.searchTerm) {
      this.isLoading = true;
      try {
        const res = await this.fetchClients({
          page,
          limit: this.pageSize,
          search,
        });
        // se lo store ha fatto swallow del 404 e ti dà [] con search attivo
        if (Array.isArray(res) && res.length === 0 && (search || "").trim()) {
          this.errorMessage = "Nessun cliente per la ricerca richiesta.";
          this.$toast.error(this.errorMessage);
        }
        return res;
      } catch (error) {
        if (error?.response?.status === 404 && page !== 1) {
          // se la pagina richiesta non ha risultati, riprova la prima
          try {
            await this.fetchClients({
              page: 1,
              limit: this.pageSize,
              search,
            });
            this.pagination.currentPage = 1;
            return;
          } catch (_) {
            /* ignora, gestiamo sotto */
          }
        }

        // messaggio come per i preventivi, ma per i clienti
        this.$nextTick(() => {
          const defaultMsg =
            this.searchTerm && this.searchTerm.trim()
              ? "Nessun cliente per la ricerca richiesta."
              : "Non esistono clienti.";
          this.errorMessage =
            error?.response?.data?.message || // <-- usa 'message' dal server
            error?.response?.data?.details ||
            defaultMsg;
          this.$toast.error(this.errorMessage);
        });
      } finally {
        this.isLoading = false;
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.getClients(page);
    },

    async onSearch() {
      this.isLoading = true;
      try {
        await this.getClients(1, this.searchTerm);
        // if (Array.isArray(res) && res.length === 0) {
        //   this.$toast.error("Nessun cliente per la ricerca richiesta.");
        // }
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Nessun cliente per la ricerca richiesta.";
        this.$toast.error(msg);
      } finally {
        this.isLoading = false;
      }
    },

    async onResetSearch() {
      this.isLoading = true;
      try {
        this.searchTerm = "";
        await this.getClients(1, "");
      } catch {
        this.errorMessage = "Errore durante il reset della ricerca.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    goToEditClient(clientId) {
      this.$router.push({ name: "edit-client", params: { clientId } });
    },

    // async onArchiveClient(clientId) {
    //   // Logica per conferma e chiamata API
    //   const conferma = window.confirm(
    //     "Sei sicuro di voler archiviare il cliente?"
    //   );
    //   if (!conferma) return;

    //   try {
    //     await this.archiveClient(clientId);
    //     this.successMessage = "Cliente archiviato con successo.";
    //   } catch (err) {
    //     console.error(err);
    //     this.errorMessage = "Impossibile archiviare il cliente.";
    //   }
    // },

    async confirmArchive() {
      if (!this.selectedClient) return;
      try {
        this.archiving = true;
        // se la tua action accetta solo l'id, basta passare quello.
        await this.archiveClient(this.selectedClient.id);

        this.successMessage = "Cliente archiviato con successo.";
        this.$toast.success(this.successMessage);
        this.showArchiveModal = false;

        // ricarica lista per riflettere lo stato
        this.getClients(1);
      } catch (err) {
        console.error(err);
        this.errorMessage = "Impossibile archiviare il cliente.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.archiving = false;
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.name === "customers" && from.name !== "customers") {
        this.getClients(1);
      }
    },
  },
  mounted() {
    this.getClients(1).then(() => this.fitPageSize());
  },
};
</script>

<style src="@/css/ClientPage.css" />
